module.exports = __webpack_public_path__ + "img/work2_1.a5ae1217.png";